<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-passing-grade-alumni-detail" data-bs-toggle="modal" data-bs-target="#passing-grade-alumni-detail-modal-form">Klik</button>
        <div class="modal" id="passing-grade-alumni-detail-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{university_name}}
                                </div>
                                <div class="d-block mt-2">{{ major_name }}</div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-passing-grade-alumni-detail">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <form>
                                    <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                        <input class="form-control list-search" type="search" placeholder="Cari data siswa disini..." v-model="keyword">
                                            <span class="input-group-text">
                                            <i class="fa-solid fa-search"></i>
                                        </span>
                                    </div>
                                </form>
                            </div>

                            <div v-if="filteredDataUsers.length > 0" class="table-responsive">
                                <table class="table table-sm table-hover card-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width:5%">No</th>
                                            <th>Nama</th>
                                            <th>Universitas</th>
                                            <th class="text-center">PM Rapor</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="list fs-base">
                                        <tr v-for="(item, index) in filteredDataUsers" :key="index">
                                            <td class="text-center">{{ ++index }}</td>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <div class="d-block me-3">
                                                        <div class="avatar avatar-xs">
                                                            <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                                        </div>
                                                    </div>
                                                    <div class="d-block">
                                                        <div class="d-block font-bold">
                                                            {{ item.name }}
                                                            <br/><span v-if="item.detail_score == 1" class="badge bg-success"><i class="fa-solid fa-star me-2"></i>Ada detail nilai</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-block mb-1">
                                                    <div class="d-block font-bold text-pink">{{ item.university_name }}</div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <div class="d-block small text-muted">Jurusan</div>
                                                            <div class="d-block text-sm">{{ item.major_name }}</div>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="d-block small text-muted">Tahun</div>
                                                            <div class="d-block text-sm">{{ item.graduation_year }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="box-score">
                                                    <span>{{ item.score_passing_grade }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-right">
                                                    <button type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" v-on:click="editData(item.id)">
                                                        <i class="fa-solid fa-pencil"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-white-naked btn-sm text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" v-on:click="deleteData(item.id)">
                                                        <i class="fa-solid fa-trash-can"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="filteredDataUsers.length < 1" class="mt-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-block text-center py-4">
                                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-between border-top pt-4">
                            <div class="d-block small"></div>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close">
                                    <div class="btn-s-1-inner">Tutup</div>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PassingGradeAlumniDetail',
    data() {
        return {
            university_name  : '',
            major_name       : '',
            data_users       : [],
            keyword          : ""
        }
    },
    computed: {
        filteredDataUsers() {
            const keyword = this.keyword.toLowerCase();
            return this.data_users.filter(item => {
                const name = item.name.toLowerCase();
                return name.includes(keyword);
            });
        },
    },
    methods: {
        loadForm: function(params="") {
            this.university_name    = params.university_name;
            this.major_name         = params.major_name;
            this.data_users         = params.data_users;

            document.getElementById('btn-modal-passing-grade-alumni-detail').click();
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-alumni/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                const indexToDelete = this.data_users.findIndex(item => item.id === id);
                                if (indexToDelete !== -1) {
                                    this.data_users.splice(indexToDelete, 1);
                                }
                                this.$parent.$children[0].$children[0].getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        },
        editData: function(id) {
            document.getElementById('btn-close-modal-passing-grade-alumni-detail').click();
            this.$parent.passing_grade_alumni_form(id)
        }
        
    },
}
</script>
